import { Element, type EnfRecord } from 'eolib';
import type { Graphics } from 'pixi.js';

// The ENF element is authoritative. Do not infer a different type from a name or sprite.
export const ELEMENT_BADGES = {
  [Element.None]: { name: 'Neutral', color: 0xb9bec8 },
  [Element.Light]: { name: 'Light', color: 0xffe68a },
  [Element.Dark]: { name: 'Dark', color: 0xbe8aff },
  [Element.Earth]: { name: 'Earth', color: 0xc99a5b },
  [Element.Wind]: { name: 'Wind', color: 0x7debc0 },
  [Element.Water]: { name: 'Water', color: 0x71c8ff },
  [Element.Fire]: { name: 'Fire', color: 0xff885c },
} as const;

export function npcElementBadge(element: number) {
  return ELEMENT_BADGES[element as keyof typeof ELEMENT_BADGES] ?? null;
}

export function npcElementDetails(record: Pick<EnfRecord, 'element' | 'elementDamage' | 'elementWeakness' | 'elementWeaknessDamage'>): string {
  const parts: string[] = [];
  const own = npcElementBadge(record.element), weak = npcElementBadge(record.elementWeakness);
  // Match the server's percent limits, rather than advertise ineffective PUB values.
  if (own && record.element !== Element.None && record.elementDamage > 0) parts.push(`Resists ${own.name} ${Math.min(75, record.elementDamage)}%`);
  if (weak && record.elementWeakness !== Element.None && record.elementWeaknessDamage > 0) parts.push(`Weak to ${weak.name} +${Math.min(100, record.elementWeaknessDamage)}%`);
  return parts.join(' / ');
}

/** Small faceted gem drawn in the existing Pixi UI, without external fonts or image requests. */
export function drawElementGem(g: Graphics, x: number, y: number, color: number): void {
  g.poly([x+7,y,x+13,y+5,x+7,y+14,x+1,y+5],true).fill(color).stroke({color:0x17121f,width:2});
  g.poly([x+7,y+2,x+3,y+5,x+7,y+6],true).fill({color:0xffffff,alpha:.65});
  g.poly([x+7,y+6,x+11,y+5,x+7,y+12],true).fill({color:0x000000,alpha:.25});
}
